import React from "react";
import { useOktaAuth } from "@okta/okta-react";
import { Navigate, useLocation } from "react-router-dom";
import { DashboardLoader } from "../../utils/Loading";

const RequireAuth = ({ children }) => {
  const { authState } = useOktaAuth();
  const location = useLocation();

  if (!authState || authState.isPending) {
    return <DashboardLoader />;
  }

  if (!authState.isAuthenticated) {
    // Save to localStorage BEFORE the Okta full-page redirect wipes router state
    const rfcPath = location.pathname + location.search;
    if (rfcPath.includes('/rfc-library/')) {
      localStorage.setItem("post_login_redirect", rfcPath);
      console.log("RequireAuth: Saved RFC path:", rfcPath);
    }
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  return children;
};

export default RequireAuth;